import React from "react";
import styled from "styled-components";
import { FaFacebook, FaTwitter, FaInstagram, FaCopyright,FaAt  } from "react-icons/fa";
import { FaLocationDot, FaPhone } from "react-icons/fa6";

const Footer1 = () => {
  return (
    <FooterContainer>
      <div className="left-section">
        <h3 style={{fontFamily:"Play"}}>MShine Enterprises</h3>
        <h6 style={{fontFamily:"Inter"}}>A Part of Mahadevi Transport since 1979</h6>
        <p>Thank you for visiting our website.</p>
        <p>We appreciate your interest in M Shine</p>
        <br></br>
        <p><FaCopyright className="cc-icon"/> 2024 M Shine Enterprises. All rights reserved</p>
      </div>
      <div className="right-section">
        <p><FaLocationDot className="location-icon" /> Plot No 156-A,Baikampady Industrial Area,Mangalore,Karnataka-575011</p>
        <p><FaAt /> mshineenterprises@yahoo.com</p>
        <p><FaPhone className="phone-icon" /> 8970147101</p>
        
        <div className="social-icons">
          {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a> */}
          {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a> */}
          <a href="https://www.instagram.com/mshine_enterprises?igsh=MXFoNDJzcTR5Zjd5Zw==" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
        </div>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: linear-gradient(to left, #f0f0f0, #fff);
  color: #333;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  .left-section, .right-section {
    flex: 1;

    h3 {
      margin-bottom: 10px;
    }

    p {
      margin: 0;
    }
  }

  .right-section {
    text-align: right;

    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .phone-icon,.location-icon,.cc-icon{
    &:hover {
        color: #ffc107;
      }
  }
  .social-icons {
    margin-top: 10px;

    a {
      margin: 0 5px;
      font-size: 24px;
      color: inherit;
      text-decoration: none;

      &:hover {
        color: #ffc107;
      }
    }

    svg {
      vertical-align: middle;
    }
  }

  @media (max-width: 768px) {
    .left-section {
      margin-bottom: 20px;
    }
  }
`;

export default Footer1;
